import React from 'react'

const PlayVideoIcon = ({
width = 48,
height = 48,
color = 'currentColor',
...props
}) => {
return (
<svg
viewBox="0 0 48 48"
width={width}
height={height}
fill={color}
aria-hidden="true"
{...props}
> <path d="M15 9.8c0-1.65 1.82-2.67 3.22-1.8l23.15 14.2a2.12 2.12 0 0 1 0 3.6L18.22 40C16.82 40.87 15 39.85 15 38.2V9.8Z" /> </svg>
)
}

export default PlayVideoIcon
